import { Empty } from "antd";
interface Iprops {
    description?: string;
    image?: React.ReactNode;
}
export const ModuleEmpty = (props: Iprops) => <Empty {...props} />;
